import type { IUser } from './IUser'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type IUserState = IUser

const initialState: IUserState = {} as IUserState

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUserSucceeded: (state, action: PayloadAction<IUser>) => ({
      ...state,
      ...action.payload,
    }),
    updateColumnOrderSucceeded: (state, action: PayloadAction<string[]>) => ({
      ...state,
      columnOrders: [...action.payload],
    }),
    updatePurchaseTermsSucceeded: (state, action: PayloadAction<string>) => ({
      ...state,
      purchaseTerms: action.payload,
    }),
  },
})

export default userSlice.reducer

export const {
  getUserSucceeded,
  updateColumnOrderSucceeded,
  updatePurchaseTermsSucceeded,
} = userSlice.actions
